import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=4f2fb7a5"
import script from "./DateInput.js?vue&type=script&lang=js&external"
export * from "./DateInput.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports